
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

import { MainLayoutComponent } from './layout/main-layout/main-layout.component';

const routes: Routes = [

  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'tickets',
        loadChildren: () => import('./tickets/tickets.module').then(m => m.TicketsPageModule),
        data: { title: 'Tickets' }
      },

      {
        path: 'emails',
        loadChildren: () => import('./emails/emails.module').then(m => m.EmailsPageModule),
        data: { title: 'Emails' }
      },
      {
        path: 'unidades',
        loadChildren: () => import('./unidades/unidades.module').then(m => m.UnidadesPageModule),
        data: { title: 'Unidades' }
      },
      {
        path: 'pagos',
        loadChildren: () => import('./pagos/pagos.module').then(m => m.PagosPageModule),
        data: { title: 'Pagos' }
      },
      {
        path: 'inventario',
        loadChildren: () => import('./inventario/inventario.module').then(m => m.InventarioPageModule),
        data: { title: 'Inventario' }
      },
      {
        path: 'presupuestos',
        loadChildren: () => import('./presupuestos/presupuestos.module').then(m => m.PresupuestosPageModule),
        data: { title: 'Presupuestos' }
      },
      {
        path: 'ajustes',
        loadChildren: () => import('./ajustes/ajustes.module').then(m => m.AjustesPageModule),
        data: { title: 'Ajustes' }
      },
      {
        path: 'perfil',
        loadChildren: () => import('./perfil/perfil.module').then(m => m.PerfilPageModule),
        data: { title: 'Mi Perfil' }
      },
      {
        path: 'home',
        loadChildren: () => import('./home/home.module').then(m => m.HomePageModule),
        data: { title: 'Home' }
      },
      {
        path: 'test',
        loadChildren: () => import('./test/test.module').then(m => m.TestPageModule),
        data: { title: 'Test Page' }
      },
      {
        path: 'whatsapp',
        loadChildren: () => import('./pages/whatsapp/whatsapp.module').then(m => m.WhatsappPageModule),
        data: { title: 'Whatsapp' }
      },
      {
        path: 'reportes',
        loadChildren: () => import('./pages/reportes/reportes.module').then(m => m.ReportesPageModule),
        data: { title: 'Reportes' }
      },
      {
        path: 'calendario',
        loadChildren: () => import('./pages/calendario/calendario.module').then(m => m.CalendarioPageModule),
        data: { title: 'Calendario' }
      },
      {
        path: 'repositorio',
        loadChildren: () => import('./pages/repositorio/repositorio.module').then(m => m.RepositorioPageModule),
        data: { title: 'Librería' }
      },
      {
        path: 'registros',
        loadChildren: () => import('./pages/empleados/registros/registros.module').then(m => m.RegistrosPageModule),
        data: { title: 'Registros' }
      },
      {
        path: 'seguimiento/empleados',
        loadChildren: () => import('./pages/seguimiento/seguimiento.module').then(m => m.SeguimientoPageModule),
        data: { title: 'Seguimiento Empleados', role: 2 }
      },
      {
        path: 'seguimiento/proveedores',
        loadChildren: () => import('./pages/seguimiento/seguimiento.module').then(m => m.SeguimientoPageModule),
        data: { title: 'Seguimiento Proveedores', role: 3 }
      },
      {
        path: 'sugerencias',
        loadChildren: () => import('./pages/sugerencias/sugerencias.module').then(m => m.SugerenciasPageModule),
        data: { title: 'Sugerencias' }
      },
      {
        path: '',
        redirectTo: 'tickets',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'bancos',
    loadChildren: () => import('./bancos/bancos.module').then(m => m.BancosPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: 'reload',
      initialNavigation: 'enabledNonBlocking'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
